import { render, staticRenderFns } from "./BoProduct.vue?vue&type=template&id=39fb4802&"
import script from "./BoProduct.vue?vue&type=script&lang=js&"
export * from "./BoProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports